<script setup lang="ts">
import { onLaunch, onShow, onHide } from '@dcloudio/uni-app'
import { useAppStore } from '@/store/modules/app'
import { useUserStore } from '@/store/modules/user'
import { useQuotesRealtimeStore } from '@/store/modules/quotes-realtime'
import { hasStoredSession } from '@/utils/auth'
import { hideBootSplashAfterReady } from '@/utils/splash'
import { preloadMainTabs } from '@/utils/tab-nav'

import { installChunkReloadGuard } from '@/utils/chunk-reload'


const appStore = useAppStore()
const userStore = useUserStore()
const quotesRt = useQuotesRealtimeStore()

onLaunch(() => {
  const startedAt = Date.now()
  appStore.initSystemInfo()

  installChunkReloadGuard()
  quotesRt.connect()
  preloadMainTabs()

  void userStore.restoreSession().catch(() => {}).finally(() => {

    void hideBootSplashAfterReady(startedAt)

  })
})

onShow(() => {

  quotesRt.connect()

  if (hasStoredSession() && userStore.sessionReady && !userStore.token) {
    void userStore.restoreSession()
  }
})

onHide(() => {

  quotesRt.disconnect()

})
</script>

<style lang="scss">
@import '@/styles/global.scss';


/* 全站统一骨架加载：彻底移除一切内置转圈 spinner
   （分包加载、uni.showLoading、scroll-view 默认刷新圈等） */
uni-loading,
.uni-loading,
.uni-scroll-view-refresh-inner {
  display: none !important;
}

/* 页面异步 chunk 加载占位：不展示骨架，避免 Tab 切换闪一下 */
.uni-async-loading {
  display: none !important;
}

html body,
html uni-page-body {
  background-color: #f8f3ea;
}

html,
body {
  height: 100%;
  overflow: hidden;
  overscroll-behavior: none;
}

uni-app,
uni-page {
  height: 100%;
  overflow: hidden;
}

uni-page-wrapper {
  height: 100%;
}

uni-page-body {
  height: 100%;
  overflow-y: auto;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
}

uni-page-body::-webkit-scrollbar {
  display: none;
  width: 0;
}

/* 全站实时价：变价底色短闪（涨红跌绿），对齐行情软件习惯 */
.price-live--flash-up {
  animation: csc-quote-flash-up 0.48s ease;
}

.price-live--flash-down {
  animation: csc-quote-flash-down 0.48s ease;
}

@keyframes csc-quote-flash-up {
  0% {
    background-color: rgba(217, 54, 54, 0.3);
  }
  100% {
    background-color: transparent;
  }
}

@keyframes csc-quote-flash-down {
  0% {
    background-color: rgba(31, 174, 85, 0.3);
  }
  100% {
    background-color: transparent;
  }
}

</style>
